export default __webpack_public_path__ + "static/media/annie-spratt.a78c88c5.jpg";